const SUPPRESSED_CONSOLE_METHODS = [
  "debug",
  "info",
  "log",
  "warn",
  "error",
];

export const suppressProductionConsole = ({
  environment = process.env.NODE_ENV,
  targetConsole = typeof console === "undefined" ? null : console,
} = {}) => {
  if (environment !== "production" || !targetConsole) {
    return false;
  }

  SUPPRESSED_CONSOLE_METHODS.forEach((method) => {
    if (typeof targetConsole[method] === "function") {
      try {
        targetConsole[method] = () => {};
      } catch (_error) {
        // Certains environnements verrouillent l'objet console.
      }
    }
  });

  return true;
};

suppressProductionConsole();
